import React from 'react';
import MainLayout from '../layouts/MainLayout';
import { NotificationProvider } from '../contexts/NotificationContext';

const MainLayoutWrapper = ({ isDarkMode, toggleTheme, children }) => {
  return (
    <NotificationProvider>
      <MainLayout isDarkMode={isDarkMode} toggleTheme={toggleTheme}>
        {children}
      </MainLayout>
    </NotificationProvider>
  );
};

export default MainLayoutWrapper;
